import { useState } from 'react';

import { parseColorString } from '@/utils/colorConversions';

type UseHexInputReturn = {
  colorInput: string;
  isHexInputVisible: boolean;
  isValid: boolean;
  setColorInput: (value: string) => void;
  setIsHexInputVisible: (visible: boolean) => void;
  handleHexInputChange: (value: string) => string | null;
  handleHexInputBlur: () => void;
  handleHexInputKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => boolean;
  reset: () => void;
};

export function useHexInput(onColorChange: (color: string) => void): UseHexInputReturn {
  const [colorInput, setColorInput] = useState('');
  const [isHexInputVisible, setIsHexInputVisible] = useState(false);

  const handleHexInputChange = (value: string): string | null => {
    setColorInput(value);
    const parsed = parseColorString(value);

    if (parsed) {
      onColorChange(parsed);
    }

    return parsed;
  };

  const handleHexInputBlur = () => {
    setIsHexInputVisible(false);
    setColorInput('');
  };

  const handleHexInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): boolean => {
    if (e.key === 'Enter' || e.key === 'Escape') {
      setIsHexInputVisible(false);
      setColorInput('');

      return true;
    }

    return false;
  };

  const reset = () => {
    setColorInput('');
    setIsHexInputVisible(false);
  };

  const isValid = colorInput === '' || parseColorString(colorInput) !== null;

  return {
    colorInput,
    isHexInputVisible,
    isValid,
    setColorInput,
    setIsHexInputVisible,
    handleHexInputChange,
    handleHexInputBlur,
    handleHexInputKeyDown,
    reset,
  };
}
